<header class="bg-white">
  <h1 [class.logo]="!title" [class.title]="!!title">
    <img *ngIf="!title" src="/assets/images/logo.png" alt="Cuepid"/>
    <span *ngIf="!!title">{{ title }}</span>
  </h1>
</header>
